import { useMemo } from 'react';

import { demoWoopScalingPoliciesList } from '@cast/fixtures';

import { useWorkloadScalingPoliciesQuery } from 'hooks/queries/workload-optimization';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

import { useIsWoopDemoMode } from './useIsWoopDemoMode';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useWorkloadScalingPolicies = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { cluster } = useCluster();
  const isWoopDemoMode = useIsWoopDemoMode();
  const demoScalingPoliciesFixture = useMemo(
    () => () => demoWoopScalingPoliciesList().then((data) => data.items),
    []
  );

  const queryResult = useWorkloadScalingPoliciesQuery({
    clusterId: cluster.id,
    enabled: !isWoopDemoMode && enabled,
  });

  const policiesDataOrFixture = useDataOrFixture(
    queryResult.policies,
    demoScalingPoliciesFixture,
    isWoopDemoMode
  );

  return { ...queryResult, policies: policiesDataOrFixture };
};
